import { Component, OnInit, Inject, Input, Optional } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fadeIn } from 'src/app/animations';
import { UserApiService } from 'src/app/core/services/http/user-api.service';
import { SessionStoreService } from 'src/app/core/services/stores/session-store.service';
import { figLogoUrl } from 'src/app/shared/constants/misc.constants';
import { ConfirmationData } from 'src/app/shared/models/modal-data.models';
import { User } from 'src/app/shared/models/user.models';
import { ConfirmationComponent } from '../confirmation/confirmation.component';

@Component({
  selector: 'app-user-logo-upload',
  templateUrl: './user-logo-upload.component.html',
  animations: [fadeIn]
})
export class UserLogoUploadComponent implements OnInit {
  dragover: boolean = false;
  uploadingFile!: File | null;
  user!: User;
  logo!: string | null;
  figLogo: string = figLogoUrl;
  refresh: boolean = false;
  previewUrl!: string | null;
  snackbarData: { class: 'is-success' | 'is-error', message: string } = {
    message: '',
    class: 'is-error',
  };
  showInlineSnackbar: boolean = false;

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<UserLogoUploadComponent>,
    private userApiService: UserApiService,
    private sessionStore: SessionStoreService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
  ) { }

  ngOnInit(): void {
    this.user = this.sessionStore.User;
    this.logo = this.data.logo;
  }

  uploadLogo(): void {
    const formData = new FormData();
    formData.append('user_logo', this.uploadingFile as File, this.uploadingFile?.name);
    this.userApiService.postUserLogo(this.user.Id, formData).subscribe(res => {
      console.log(res);
      this.refresh = true;
      this.user.HasUserLogo = true;
      this.dialogRef.close({ refresh: this.refresh, hasPhoto: this.user.HasUserLogo });
    }, (error) => {
      console.log('Failed');
    });
  }

  dragOverHandler(event: any) {
    this.dragover = true;
    event.preventDefault();
    event.stopPropagation();
  }

  uploadFiles(event: any) {
    this.dragover = false;
    const file = event.target.files[0];
    if (this.isValidFile(file).isSuccess) {
      this.uploadingFile = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.previewUrl = reader.result as string;
      };
      event.target.value = '';
    } else {
      this.snackbarData = {
        message: '',
        class: 'is-error',
      };

      if (this.isValidFile(file).errorType == 'size') this.snackbarData.message = 'File size must be less than 2MB.';
      if (this.isValidFile(file).errorType == 'ext') this.snackbarData.message += ' File type must be a valid image type.';
      this.snackbarData.message += ' Please select a different logo image.';
      this.showInlineSnackbar = true;
    }
  }

  isValidFile(file: File): { isSuccess: boolean, errorType: 'size' | 'ext' | null } {
    const fileName: string = file.name;
    const fileSize: number = file.size;
    const idxDot = fileName.lastIndexOf('.') + 1;
    const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    const extCheck: boolean = (extFile == 'jpg' || extFile == 'jpeg' || extFile == 'png');
    const sizeCheck: boolean = fileSize <= 2000000;

    return {
      isSuccess: extCheck && sizeCheck,
      errorType: !extCheck ? 'ext' : !sizeCheck ? 'size' : null,
    };
  }

  removeFile() {
    this.uploadingFile = null;
    this.previewUrl = null;
  }

  closeModal(event: any, refresh: boolean): void {
    this.dialogRef.close({ refresh: refresh, hasPhoto: this.user.HasUserLogo });
  }

  deleteLogo() {
    this.userApiService.deleteUserLogo(this.user.Id).subscribe(res => {
      console.log(res);
      this.user.HasUserLogo = false;
      this.logo = null;
      this.refresh = true;
    }, (error) => {
      console.log('Failed');
    });
  }

  confirmDeleteLogo(): void {
    const confirmDialog = this.dialog.open<ConfirmationComponent, ConfirmationData>(ConfirmationComponent, {
      data: {
        title: 'Confirm Removing Current Logo',
        message: 'Are you sure you want to remove the current logo? The default logo will be the Financial Independence Group logo.',
        confirmationButtonText: 'Remove Logo',
        isWarning: true,
      }
    });

    confirmDialog.afterClosed().subscribe(result => {
      if (result) {
        this.deleteLogo();
      } else {
        return;
      }
    });

  }
}
